{
  "80% passes. You can retake it; your best score counts.": "עוברים ב-80%. אפשר לנסות שוב; הציון הגבוה נספר.",
  "AE certified": "מוסמך/ת AE",
  "AE gate": "שער AE",
  "AE quizzes": "מבחני AE",
  "Abandoned": "ננטש",
  "Academy": "אקדמיה",
  "All sessions": "כל הסימולציות",
  "Average score": "ציון ממוצע",
  "Awaiting sign-off": "ממתין לאישור",
  "Back to the Academy": "חזרה לאקדמיה",
  "Call booked": "נקבעה שיחה",
  "Claim the product can't back": "טענה שהמוצר לא מגבה",
  "Coach sign-off": "אישור מאמן",
  "Coach view: train and certify reps and partners": "תצוגת מאמן: הכשרה והסמכה של נציגים ושותפים",
  "Coach's note": "הערת המאמן",
  "Coach's note (the trainee sees it)": "הערת מאמן (המתאמן/ת רואה אותה)",
  "Different prospects": "לקוחות שונים",
  "Discovery sessions": "סימולציות Discovery",
  "Discovery sessions passed": "סימולציות Discovery שעברו",
  "Finish and grade": "סיום וציון",
  "Graded on": "קריטריונים",
  "Handed off": "הועבר הלאה",
  "In SDR training": "בהכשרת SDR",
  "In progress": "בתהליך",
  "Invite a trainee": "הזמנת מתאמן/ת",
  "Invite language": "שפת ההזמנה",
  "Invited": "ההזמנה נשלחה",
  "Last practice": "תרגול אחרון",
  "Locked": "נעול",
  "Lost": "אבד",
  "Mark as read": "סימון כנקרא",
  "Met every AE requirement. Read the discovery sessions below, then sign off.": "עמד/ה בכל דרישות ה-AE. קראו את סימולציות ה-Discovery למטה ואז אשרו.",
  "Module not found": "המודול לא נמצא",
  "Modules": "מודולים",
  "Next step set": "נקבע צעד הבא",
  "No graded sessions yet.": "עדיין אין סימולציות עם ציון.",
  "No sessions yet.": "עדיין אין סימולציות.",
  "Nobody in the Academy yet. Invite your first rep.": "עדיין אין אף אחד באקדמיה. הזמינו את הנציג/ה הראשון/ה.",
  "Not connected here": "לא מחובר כאן",
  "Opens once you're SDR certified.": "נפתח אחרי הסמכת SDR.",
  "Partner": "שותף/ה",
  "Pass the SDR gate to book discovery calls for the founder. The AE gate, with a coach's sign-off, lets you run discovery calls and close.": "שער ה-SDR מסמיך לקבוע שיחות Discovery למייסד. שער ה-AE, עם אישור מאמן, מסמיך לנהל שיחות Discovery ולסגור.",
  "Passed with {score}%": "עברת עם {score}%",
  "Passed {score}%": "עבר {score}%",
  "Practice against a simulated prospect": "תרגול מול לקוח מדומה",
  "Price in writing": "מחיר בכתב",
  "Product truth": "אמת מוצרית",
  "Prospect": "לקוח פוטנציאלי",
  "Pushy or disrespectful": "לחץ או חוסר כבוד",
  "Quiz": "מבחן",
  "Quizzes passed": "מבחנים שעברו",
  "RELAYZA Academy": "האקדמיה של RELAYZA",
  "Reactivate": "הפעלה מחדש",
  "Ready for sign-off. Your coach will review your sessions.": "מוכן/ה לאישור. המאמן יעבור על הסימולציות שלך.",
  "Rep": "נציג/ה",
  "SDR gate": "שער SDR",
  "SDR quizzes": "מבחני SDR",
  "SDR sessions": "סימולציות SDR",
  "Save note": "שמירת הערה",
  "Scenario": "תרחיש",
  "Score": "ציון",
  "Send invite": "שליחת הזמנה",
  "Sign off as AE": "אישור כ-AE",
  "Sparring": "סימולטור",
  "Sparring sessions passed": "סימולציות שעברו",
  "Start": "התחלה",
  "Submit answers": "שליחת תשובות",
  "The capability index isn't published on this environment. Use docs/capabilities in the repository.": "אינדקס היכולות לא מפורסם בסביבה הזו. השתמשו ב-docs/capabilities שבמאגר הקוד.",
  "The prospect wrapped up. Finish to get your grade.": "הלקוח סיים את השיחה. סיימו כדי לקבל ציון.",
  "This failed the session": "זה הכשיל את הסימולציה",
  "Training and certification for RELAYZA reps and partners": "הכשרה והסמכה לנציגים ולשותפים של RELAYZA",
  "Try this instead": "נסו במקום",
  "Type": "סוג",
  "Typing…": "מקליד/ה…",
  "Unfinished": "לא הסתיים",
  "What RELAYZA does today, from the same source the chat on relayza.company answers from. When in doubt, check here before you answer. The sparring grader holds you to it.": "מה RELAYZA עושה היום, מאותו מקור שהצ'אט ב-relayza.company עונה ממנו. כשיש ספק, בודקים כאן לפני שעונים. הבודק בסימולטור מחזיק אתכם לזה.",
  "What worked": "מה עבד",
  "Where you stand": "איפה את/ה עומד/ת",
  "Write as the RELAYZA rep": "כתבו כנציג/ה של RELAYZA",
  "You": "את/ה",
  "You play the RELAYZA rep. Claude plays a business owner with a hidden profile, then grades you against the rubric. {pass}% passes; a price in writing or a claim the product can't back fails the session.": "את/ה בתפקיד הנציג/ה של RELAYZA. Claude משחק בעל/ת עסק עם פרופיל נסתר, ואחר כך נותן ציון לפי מחוון. עוברים ב-{pass}%; מחיר בכתב או טענה שהמוצר לא מגבה מכשילים את הסימולציה.",
  "Your first 90 days": "90 הימים הראשונים שלך",
  "Your grade": "הציון שלך",
  "Your reply": "התשובה שלך",
  "Your sessions": "הסימולציות שלך",
  "{done} of {n} lessons": "{done} מתוך {n} שיעורים",
  "{mark} of 5": "{mark} מתוך 5",
  "{score}%. 80% passes; read the explanations and try again.": "{score}%. עוברים ב-80%; קראו את ההסברים ונסו שוב."
}
